import React from "react";

import { Box } from "../../core";

export const PanelFooter = (otherProps: any) => (
  <Box p={4} pt={0} {...otherProps} />
);

export default PanelFooter;
